export default __webpack_public_path__ + "static/O0219-05140d43699a9f3a614ba426c7a5c921.png";